import { Space } from '@sravni/react-design-system';

import { EBS_CONFIRM_CONTENT } from '../../EbsDialogBanner.config';
import styles from '../../EbsDialogBanner.module.scss';
import { EbsInformer } from '../EbsInformer/EbsInformer';

export function EbsBannerConfirmGuide({ isMobile }: { isMobile: boolean }) {
  return (
    <Space direction="column" size={8} className={styles.gridContainer}>
      {EBS_CONFIRM_CONTENT(isMobile).map((info, step) => (
        // eslint-disable-next-line react/no-array-index-key
        <EbsInformer key={`step-id-${step}`} step={step + 1} {...info} />
      ))}
    </Space>
  );
}
